export default {
  queue: state => state.queue,
  genresList: state => state.genresList,
  title: state => state.title,
  status: state => state.status,
  errors: state => state.errors,
  errorCode: state => state.errorCode
};
